import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Pagination from "@mui/material/Pagination";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { useGetAllSubscriptionsQuery } from "api/subscription";
import { useNavigate } from "react-router";
// import FullPageLoader from "components/Loader/FullPageLoader";


const paginationSx = {
  "& .css-1awya33-MuiButtonBase-root-MuiPaginationItem-root": {
    border: "1px solid #E1E1E6",
    borderRadius: "8px",
    color: "#9EA3AE",
    background: "none",
  },
  "& .css-1awya33-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected": {
    backgroundColor: "#2b817b",
    color: "white",
    borderRadius: "8px",
  },
};


const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  "& .css-17jjc08-MuiDataGrid-footerContainer": {
    display: "none",
  },
  boxShadow: "none",
  border: "none",
  borderColor: "green",
  color: "#545359",
  "& .MuiDataGrid-cell:focus": {
    outline: "none",
    color: "#1A1824",
    border: "1px solid transparent !important",
  },
  "& .MuiDataGrid-iconButtonContainer": {
    marginLeft: "2px",
    visibility: "visible !important",
    width: "auto !important",
  },
  "& .css-gl260s-MuiDataGrid-columnHeadersInner": {
    color: "#9EA3AE",
  },
}));


const Subscription = () => {
  // const [value, setValue] = React.useState(0);
  const navigate = useNavigate()
  const [page, setPage] = useState(1)
  const [showDetailSubscription, setShowDetailSubscription] = useState(false);
  const [selectedSubs, setSelectedSubs] = useState("");
  const [AllSubsData, setAllSubsData] = React.useState([]);
  let user = localStorage.getItem("user")
  user = JSON.parse(user)
  console.log("user", user)
  console.log("userid", user?.profile?._id)
  const { data: AllSubs, isLoading } = useGetAllSubscriptionsQuery(user?.profile?._id);
  // console.log(data)
  console.log(AllSubs)

  // const 


  const subscriptionTableColumns = [

    { field: "id", headerName: "#", width: 100 },
    {
      field: "subId",
      headerName: "Id subs",
      width: 160,
    },
    {
      field: "deliveryTime",
      headerName: "Delivery Time",
      width: 160,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      width: 160,
    },
    {
      field: "subType",
      headerName: "Subscription type",
      width: 230,
      renderCell: (params) => {
        const { value } = params;
        // let label = "";
        let chipBgColor = "";
        if (value === "personal" || value?.toLowerCase() == "personal subscription") {
          chipBgColor = "#7B49E5";
          // label = "Personal subscription";
        } else if (value === "multiple") {
          chipBgColor = "#158FAD";
          // label = "Multiple subscription";
        } else if (value === "Bussines subscription") {
          chipBgColor = "#FF9933";
        } else if (value === "Single Order") {
          chipBgColor = "#7ECC49";
        } else if (value === "Weekly Subscription") {
          chipBgColor = "#FF8D85";
        } else if (value === "Monthly Subscription") {
          chipBgColor = "#158FAD";
          // label = "Multiple subscription";
        } else if (value === "Custom Subscription") {
          chipBgColor = "#FF9933";
        }
        return (
          <>
            <Box>
              <Chip
                label={value}
                variant="contained"
                sx={{
                  background: chipBgColor,
                  borderRadius: "6px",
                  color: "#fff",
                }}
              />
            </Box>
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 160,
      renderCell: (params) => {
        const { value } = params;
        let statusBtnBgColor = "",
          statusBtnBorderColor = "",
          statusBtncolor = "";
        if (value === "Paused") {
          statusBtnBgColor = "#FFF1F1";
          statusBtnBorderColor = "#DD7474";
          statusBtncolor = "#9F2D2D";
        } else {
          statusBtnBgColor = "#F1FFF7";
          statusBtnBorderColor = "#81D9A5";
          statusBtncolor = "#30A15F";
        }
        return (
          <>
            <Box
              sx={{
                border: `1px solid ${statusBtnBorderColor}`,
                bgcolor: statusBtnBgColor,
                borderRadius: "4px",
                color: statusBtncolor,
                p: "2px 9px",
              }}
            >
              {params.value}
            </Box>
          </>
        );
      },
    },
    {
      field: "endDate",
      headerName: "End Date",
      width: 160,
      renderCell: (params) => {
        const { value } = params;
        // Use substring(0, 6) to get the first 6 characters of the endDate
        const shortenedEndDate = value ? value.substring(0, 10) : "";
        return (
          <>
            <Box>{shortenedEndDate}</Box>
          </>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 130,
      renderCell: (params) => {
        return (
          <>
            <Box>
              <Button
                sx={{ color: "#42C677", textTransform: "none" }}
                onClick={() => {
                  // setShowDetailSubscription(true);
                  navigate(`/Mealplan/${params.row._id}`);
                }}
                variant="text"
              >
                Detail
              </Button>
            </Box>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    const tmpData = [];
    if (AllSubs && AllSubs.data)
      AllSubs.data.map((item, index) => {
        // console.log(AllSubs.data)
        // if (item?.user == user?.profile?._id) {
        tmpData.push({ ...item, id: ++index });
        // }

      });
    let startIndex = page * 6 - 6
    let endIndex = startIndex + 6
    const data = tmpData.slice(startIndex, endIndex > tmpData?.length ? tmpData?.length : endIndex)
    // console.log("AllSubs.data", AllSubs.data)
    setAllSubsData(data);
  }, [page, AllSubs]);

  // console.log("AllSubsData", AllSubs);

  const handleChange = (e, value) => {
    setPage(value)
  }


  return (
    <>
      {/* <DashboardLayout> */}
      <Box width="100%">
        <Box width="100%">
          {isLoading ? (
            <>
              Loading...
            </>
          ) : (
            <Box
              width="100%"
              border="1px solid #e1e1e6"
              p="10px 20px"
              borderRadius="8px"
              minHeight="60vh"
            >

              <Box sx={{ width: "100%" }}>
                <StyledDataGrid
                  rows={AllSubsData}
                  columns={subscriptionTableColumns}
                  disableSelectionOnClick
                  autoHeight
                  hideFooterPagination={true}
                />
              </Box>
              <Pagination
                sx={paginationSx}
                style={{
                  margin: "20px 0",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
                count={Math.ceil(AllSubs.data.length / 6)}
                page={page}
                onChange={handleChange}
              />
            </Box>
          )}
        </Box>
      </Box>
      {/* </DashboardLayout> */}
    </>
  );
};

export default Subscription;
